import { render, staticRenderFns } from "./package.vue?vue&type=template&id=6aa9025b&scoped=true&"
import script from "./package.vue?vue&type=script&lang=js&"
export * from "./package.vue?vue&type=script&lang=js&"
import style0 from "./package.vue?vue&type=style&index=0&id=6aa9025b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9025b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa9025b')) {
      api.createRecord('6aa9025b', component.options)
    } else {
      api.reload('6aa9025b', component.options)
    }
    module.hot.accept("./package.vue?vue&type=template&id=6aa9025b&scoped=true&", function () {
      api.rerender('6aa9025b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/activity/program_manage/form/components/package.vue"
export default component.exports